<template>
  <form @submit.prevent="sendSmsForChatUsers">

    <button type="button" class="btn btn-sm btn-primary px-5 mx-1 rounded-pill" @click="selectAll()">انتخاب همه</button>
    <button type="button" class="btn btn-sm btn-primary px-5 mx-1 rounded-pill" @click="removeAll()">پاک کردن</button>

    <div class="my-4">
      <div class="form-check" v-for="(user,index) in users">
        <input v-model="selectedItems" class="form-check-input" name="sms_user" type="checkbox" :value="user"
               :id="`select_user_${index}`">
        <label class="mr-4 form-check-label" :for="`select_user_${index}`">
          {{ user.name }} {{ user.last_name }}
        </label>
      </div>
    </div>


    <div class="text-center">
      <button type="submit" ref="submit_button" class="btn btn-primary px-5 rounded-pill" v-t="`chat.sms.submit_button`"></button>
    </div>

  </form>
</template>

<script>
import {defineComponent} from 'vue'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default defineComponent({
  name: "NotifyChatUsers",
  props: {
    usersInChat: {},
    chat: {}
  },
  data() {
    return {
      selectedItems: [],
    }
  },
  computed: {
    users() {
      let users = []

      this.usersInChat.forEach(item => {
        if (item.group == null) {
          users.push(item.user)
        } else {
          let group = item.group;
          group.users.forEach(userItem => {
            let userItemTemp = Object.assign({}, userItem)
            userItemTemp.last_name = `${userItemTemp.last_name} (${group.name})`
            users.push(userItemTemp)
          })

        }
      })


      return users
    }
  },
  methods: {
    sendSmsForChatUsers() {
      let userIds = this.selectedItems.map(item => {
        return item.id
      })

      let form = {
        chat_id: this.chat.id,
        users: userIds
      }
      let req = this.$store.dispatch('Chat/sendSmsForChatUsers', form)
      this.$refs.submit_button.classList.toggle('d-none')
      req.then(res => {

        toast("پیام با موفقیت ارسال شد", "پیام با موفقیت ارسال شد")
      }).catch(err=>{
        this.$refs.submit_button.classList.toggle('d-none')
      })
    },
    selectAll() {
      this.selectedItems = this.users
    },
    removeAll() {
      this.selectedItems = []
    }
  },
})
</script>


<style scoped>

</style>